import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Axios from "../comp/Utils/axios";
import SummaryAPI from "../comp/Commson/summaryApi";
import { AxiosToastError } from "../comp/Utils/AxiosToastError";
import fetchUserDetails from "../comp/Utils/fetchUserDetail";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../comp/Store/Userslice";

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Login component for user authentication
 *
 * Handles user login and redirects to dashboard if successful
 *
 * @returns {JSX.Element} Login form component
 */
/*******  10819093-9e29-4bf4-a8cd-5973b1662b21  *******/
const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch()

  const [data, setData] = useState({
    email: "",
    password: "",
  });

  // handle input change
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // validation function
  const validate = () => {
    if (!/\S+@\S+\.\S+/.test(data.email)) {
      toast.error("Please enter a valid email");
      return false;
    }
    if (data.password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return false;
    }
    return true;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const response = await Axios.post(
        SummaryAPI.login.url,
        {
          email: data.email,
          password: data.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        toast.success("Login successful 🎉");
        localStorage.setItem("accessToken",response.data.data.accessToken)
        localStorage.setItem("accessToken",response.data.data.refreshToken)

        const userDetail = await fetchUserDetails()
        dispatch(setUserDetails(userDetail.data))

        setData({
          email: "",
          password: "",
        });
        navigate("/");
      } else {
        toast.error(response?.data?.message || "Login failed");
      }
    } catch (error) {
      AxiosToastError(error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-800 text-center">Login</h2>
        <p className="text-gray-500 text-center text-sm mt-2">
          Welcome back to Laminance Cabinetry 🚀
        </p>

        <form onSubmit={handleLogin} className="mt-6 space-y-4">
          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={data.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              className="w-full mt-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-400 focus:outline-none"
            />
          </div>

          {/* Password */}
          <div className="relative">
            <label className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={data.password}
              onChange={handleChange}
              required
              placeholder="Enter password"
              className="w-full mt-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-400 focus:outline-none"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-9 text-gray-500"
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>

          {/* Forgot Password */}
          {/* <div className="text-right">
            <span
              onClick={() => navigate("/forgot-password")}
              className="text-sm text-indigo-500 cursor-pointer hover:underline"
            >
              Forgot Password?
            </span>
          </div> */}

          {/* Login Button */}
          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg font-medium transition-all"
          >
            Login
          </button>
        </form>

        {/* Don't have an account */}
       
      </div>
    </div>
  );
};

export default Login;
